import { useMutation, useQueryClient } from '@tanstack/react-query';
import { onboardingService } from '../api/onboarding.service';
import { ORGANIZATIONS_KEYS } from '../../hooks/queryKeys';
import type { OnboardingPayload } from '../types';

export function useCompleteOnboarding() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: OnboardingPayload) => onboardingService.complete(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_KEYS.all });
    },
  });
}
